import { render, staticRenderFns } from "./FormRegistratorContainer.vue?vue&type=template&id=9658b7c2&"
import script from "./FormRegistratorContainer.vue?vue&type=script&lang=js&"
export * from "./FormRegistratorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports